import React from 'react';
import ReactDOM from 'react-dom/client';
import { AppProvider, Page, Banner } from '@shopify/polaris';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import enTranslations from '@shopify/polaris/locales/en.json';
import '@shopify/polaris/build/esm/styles.css';
import App from './App';

// AppBridge v4.x runs as a CDN script + `<meta name="shopify-api-key">` tag
// configured in `index.html`. No `<Provider>` wrapper is needed — components
// pull the `shopify` global via `useAppBridge()`. (R8 deviation from plan-doc.)

const params = new URLSearchParams(window.location.search);
const host = params.get('host') ?? '';

const root = ReactDOM.createRoot(document.getElementById('root')!);

if (!host) {
  // R9: Direct-URL / dev loads without a `host` param crash AppBridge v4
  // (`forceRedirect: true` + empty host = unrecoverable). Render a friendly
  // Polaris message and skip the AppBridge-dependent tree entirely.
  root.render(
    <React.StrictMode>
      <AppProvider i18n={enTranslations}>
        <Page title="Unifd">
          <Banner tone="info" title="Open this app from your Shopify admin">
            <p>
              This page is meant to be loaded inside the Shopify admin iframe.
              Install or open the Unifd app from your store admin to continue.
            </p>
          </Banner>
        </Page>
      </AppProvider>
    </React.StrictMode>,
  );
} else {
  const queryClient = new QueryClient({
    defaultOptions: { queries: { retry: 1, refetchOnWindowFocus: false } },
  });

  root.render(
    <React.StrictMode>
      <AppProvider i18n={enTranslations}>
        <QueryClientProvider client={queryClient}>
          <App />
        </QueryClientProvider>
      </AppProvider>
    </React.StrictMode>,
  );
}
